import React, { useState, useEffect } from 'react'
import CheckboxUi from '../../UiElements/Checkbox'

const Checkbox = ({ item, value, validationMessage, handleChange, formData }) => {
  const disabled = typeof item.disabled === 'function' ? item.disabled(formData) : item.disabled || false
  const className = item.className || ''
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    setChecked(item.defaultvalue || false)
  }, [])
  useEffect(() => {
    if (value !== checked && value !== null && value !== undefined && value !== '') {
      setChecked(value)
    } else {
      setChecked(false)
      handleChange(false, item.name)
    }
  }, [value])

  // Return Input in view
  return (
    <CheckboxUi
      label={item?.label}
      description={item?.hint}
      className={(select) =>
        select ? `bg-primary-50 h-[38px] px-md rounded-md  ${className}` : `px-md h-[38px] ${className}`
      }
      defaultChecked={checked}
      onChange={(isChecked) => {
        //setChecked(isChecked)
        handleChange(isChecked, item.name)
      }}
      disabled={disabled}
    />
  )
}

export default Checkbox
